import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35170fdc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=35170fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35170fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35170fdc')) {
      api.createRecord('35170fdc', component.options)
    } else {
      api.reload('35170fdc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35170fdc&scoped=true&", function () {
      api.rerender('35170fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Exception/index.vue"
export default component.exports